/* eslint-disable import/prefer-default-export */
import {List} from 'immutable';

export function isManagedAccount(email, emailDomains = List()) {
  return emailDomains.some((domain) => {
    // Ensures that "@albert.io" passes but "@albert.io12345" fails
    return email.split('@')[1] === domain.getName();
  });
}
